import React, { useMemo, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUserInfo } from '@/hooks'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomButton from '@/components/CustomButton'
import { CardActionType } from '../index.type'

export default React.memo(function ChangeAccount() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { t } = useTranslation()
    const { userInfo } = useUserInfo()

    const changeAccountItems = useMemo(() => [
        {
            icon: "/images/my/change-email.png",
            title: t('邮箱'),
            actionType: CardActionType.Email,
            buttonText: t('更换邮箱'),
            account: userInfo?.email || '-'
        },
        {
            icon: "/images/my/change-phone.png",
            title: t('手机号'),
            actionType: CardActionType.Phone,
            buttonText: t('更换手机号'),
            account: userInfo?.phone || '-'
        },
        {
            icon: "/images/my/change-google.png",
            title: t('谷歌验证器'),
            actionType: CardActionType.Google,
            buttonText: t('更换谷歌验证器'),
            account: null
        },
    ], [userInfo?.email, userInfo?.phone, t])

    // 跳转选择校验方式页面
    const handleChangeAccount = (_actionType: CardActionType) => {
        if (_actionType === CardActionType.Email) {
            navigate('/change-account/select-verification', { state: { ...state } })
        } else if (_actionType === CardActionType.Phone) {
            navigate('/change-account/select-verification', { state: { ...state } })
        } else if (_actionType === CardActionType.Google) {
            navigate('/change-account/select-verification', { state: { ...state } })
        }
    }
    const changeAccountItem = changeAccountItems.find((item: any) => item.actionType === state?.changeType)
    return (
        <PageLayout>
            <Header leftChildren={<Back />} centerChildren={<div className="text-3.75 font-medium text-black">{changeAccountItem?.title}</div>} />
            <div className='px-6 py-6'>
                <div className='flex justify-center my-10'>
                    <img className='w-50' src={changeAccountItem?.icon} alt="icon" />
                </div>
                {
                    changeAccountItem?.account && (
                        <div className='text-center text-5 font-500 text-black break-words whitespace-normal'>
                            {changeAccountItem?.account}
                        </div>
                    )
                }
                <div className='my-6'>
                    <CustomButton
                        onClick={() => handleChangeAccount(state?.changeType)}
                    >
                        {changeAccountItems.find((item: any) => item.actionType === state?.changeType)?.buttonText}
                    </CustomButton>
                </div>
                <div className='text-base text-[#333] text-center'>
                    {t('变更安全验证将在X小时内禁止提币', { hours: 48 })}
                </div>
            </div>

        </PageLayout>
    )
})
